import { call, put, takeLatest } from "redux-saga/effects";
import {
  ADD_EMPLOYEES, CHANGE_STATUS_EMPLOYEES,
  DELETE_EMPLOYEES,
  EDIT_EMPLOYEES,
  GET_EMPLOYEES,
  GET_EMPLOYEES_SUCCESS,
} from "./employees.types";
import { httpRequestsOnErrorsActions } from "../http_requests_on_errors";
import { httpRequestsOnLoadActions } from "../http_requests_on_load";
import { httpRequestsOnSuccessActions } from "../http_requests_on_success";
import { employeesService } from "./employees.service";

function* getEmployees({ payload, type }) {
  yield put(httpRequestsOnErrorsActions.removeError(type));
  if (!payload?.noLoad) {
    yield put(httpRequestsOnLoadActions.appendLoading(type));
  }
  yield put(httpRequestsOnSuccessActions.removeSuccess(type));
  try {
    const res = yield call(
      employeesService.getEmployeesService,
      payload?.params,
    );

    yield put({
      type: GET_EMPLOYEES_SUCCESS,
      payload: res.data,
    });

    yield put(httpRequestsOnSuccessActions.appendSuccess(type));
    yield put(httpRequestsOnErrorsActions.removeError(type));
  } catch (err) {
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(
      httpRequestsOnErrorsActions.appendError(type, err?.data?.message),
    );
  } finally {
    yield put(httpRequestsOnLoadActions.removeLoading(type));
  }
}

function* addEmployee({ payload, type }) {
  yield put(httpRequestsOnErrorsActions.removeError(type));
  yield put(httpRequestsOnLoadActions.appendLoading(type));
  yield put(httpRequestsOnSuccessActions.removeSuccess(type));
  try {
    yield call(employeesService.addEmployeesService, payload.body);

    yield put(httpRequestsOnSuccessActions.appendSuccess(type));
    yield put(httpRequestsOnErrorsActions.removeError(type));
  } catch (err) {
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(
      httpRequestsOnErrorsActions.appendError(type, err?.data?.message),
    );
  } finally {
    yield put(httpRequestsOnLoadActions.removeLoading(type));
  }
}

function* editEmployee({ payload, type }) {
  yield put(httpRequestsOnErrorsActions.removeError(type));
  yield put(httpRequestsOnLoadActions.appendLoading(type));
  yield put(httpRequestsOnSuccessActions.removeSuccess(type));
  try {
    yield call(
      employeesService.editEmployeesService,
      payload?.id,
      payload?.body,
    );

    yield put(httpRequestsOnSuccessActions.appendSuccess(type));
    yield put(httpRequestsOnErrorsActions.removeError(type));
  } catch (err) {
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(
      httpRequestsOnErrorsActions.appendError(type, err?.data?.message),
    );
  } finally {
    yield put(httpRequestsOnLoadActions.removeLoading(type));
  }
}

function* deleteEmployee({ payload, type }) {
  yield put(httpRequestsOnErrorsActions.removeError(type));
  yield put(httpRequestsOnLoadActions.appendLoading(type));
  yield put(httpRequestsOnSuccessActions.removeSuccess(type));
  try {
    yield call(employeesService.deleteEmployeesService, payload?.id);

    yield put(httpRequestsOnSuccessActions.appendSuccess(type));
    yield put(httpRequestsOnErrorsActions.removeError(type));
  } catch (err) {
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(
      httpRequestsOnErrorsActions.appendError(type, err?.data?.message),
    );
  } finally {
    yield put(httpRequestsOnLoadActions.removeLoading(type));
  }
}

function* changeStatus({ payload, type }) {
  yield put(httpRequestsOnErrorsActions.removeError(type));
  yield put(httpRequestsOnLoadActions.appendLoading(type));
  yield put(httpRequestsOnSuccessActions.removeSuccess(type));
  try {
    yield call(
        employeesService.changeStatusVEmployeesService,
        payload?.id,
        payload?.body,
    );

    yield put(httpRequestsOnSuccessActions.appendSuccess(type));
    yield put(httpRequestsOnErrorsActions.removeError(type));
  } catch (err) {
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(
        httpRequestsOnErrorsActions.appendError(type, err?.data?.message),
    );
  } finally {
    yield put(httpRequestsOnLoadActions.removeLoading(type));
  }
}

export const watchEmployees = function* watchEmployees() {
  yield takeLatest(GET_EMPLOYEES, getEmployees);
  yield takeLatest(ADD_EMPLOYEES, addEmployee);
  yield takeLatest(EDIT_EMPLOYEES, editEmployee);
  yield takeLatest(DELETE_EMPLOYEES, deleteEmployee);
  yield takeLatest(CHANGE_STATUS_EMPLOYEES, changeStatus);
};
